import { Icon } from "@material-ui/core";
import "./ServiceIcon.scss";
import { useEffect, useState } from "react";
import { workImpactTypes } from "../../../Utils/GlobalVariables/Service/WorkImpactType";
import { executionMethodTypes } from "../../../Utils/GlobalVariables/Service/ExecutionMethodType";

export const ServiceIcon = (props) => {
  const { footerColor, icon, workImpact, executionMethod, selected, styled, selectedType2 } =
    props;
  const [tmpFooterColor, setFooterColor] = useState(footerColor);
  const [tmpIcon, setIcon] = useState(icon);

  useEffect(() => {
    if (Boolean(workImpact)) {
      switch (workImpact) {
        case workImpactTypes.difficult:
          setFooterColor("#FF9800");
          break;
        case workImpactTypes.impossible:
          setFooterColor("#F44336");
          break;
        case workImpactTypes.noInformation:
          setFooterColor("#748EB6");
          break;
        case workImpactTypes.possible:
          setFooterColor("#19AA8D");
          break;
        default:
          break;
      }
    }

    if (Boolean(executionMethod)) {
      switch (executionMethod) {
        case executionMethodTypes.customerIntervention:
          setIcon("airport_shuttle");
          break;
        case executionMethodTypes.localIntervention:
          setIcon("apartment");
          break;
        case executionMethodTypes.remoteIntervention:
          setIcon("headset_mic");
          break;
        case executionMethodTypes.noInformation:
          setIcon("do_disturb");
          break;
        default:
          break;
      }
    }
  }, [workImpact, executionMethod]);

  return (
    <div
      style={{ "--footerColor": tmpFooterColor, ...styled, boxShadow: selectedType2 ? " 0 0 0 4px white ,0 0 0 8px var(--BMX-error)" : "", borderRadius: selectedType2 ? "4px" : "" }}
      className={`ServiceDeliveryIcon ${selected ? "selected" : ""}`}
    >
      <Icon style={{ ...styled }} className="Icon">
        {tmpIcon}
      </Icon>
    </div>
  );
};
